<template>

<div id="app">
        <el-container class="flextext">
            <home-head></home-head>
            <el-main class="neitong_bufen_qiangzhi">
                <div class="content">
                    
                    <div class="main-head">
                        <el-row>
                            
                            <!-- <el-col :xs="8" :sm="6" :md="4" style="width: 300px">
                                <div class="search-top">选择分类：
                                    
                                </div>
                            </el-col> -->
                            
                            <el-col :xs="8" :sm="6" :md="4" style="margin-left: 100px">
                                <div class="jiance_sousuo">
                                <el-input
                                        style="margin-top: 2px;color: #c60000;
                                          border: 1px solid #c60000;border-radius: 5px;width:135px;"
                                          size="mini"
                                          placeholder="请输入内容"
                                          v-model="bidding_search_key"
                                          class="xuanze"

                                          >
                                </el-input>
                              <el-button type="danger"
                                         size="mini"
                                         style="position: relative;left: -5px;height: 30px;width: 60px "
                                         @click="do_search">搜索
                              </el-button>
                                </div>

                            </el-col>
                        </el-row>
                    </div>
                    <div style="width: 70%;float: left;">
                        <el-row :gutter="35" style="margin-top: 20px;">
                            <el-col :xs="24" :sm="24" :md="24" v-for="(item_bidding) in bidding_list" :key="item_bidding.id">
                                <div class="shebei-item" style="width: 100%; height:auto">
                                        <div class="backgd" style="text-align: left">
                                            
                                            <div class="bidding-item">
                                                <h3 class="title">
                                                    <a :href="'#/bidding/' + item_bidding.id">  
                                                        {{ item_bidding.title }}
                                                    </a>
                                                </h3>
                                                <p class="description" >{{ item_bidding.description }}</p>
                                                
                                                <el-table :data="item_bidding.item">
                                                    <el-table-column label="物料名称" prop="title"></el-table-column>
                                                    <el-table-column label="要求" prop="description"></el-table-column>
                                                </el-table>
                                                
                                                <dl class="date">
                                                
                                                    <dt class="key">
                                                        <img class="avatar" :src="url_pre + '/storage/' + item_bidding.avatar"  alt="" >
                                                    </dt>
                                                    <dd class="val">{{ item_bidding.name }}</dd>
                                                
                                                    <template v-if="item_bidding.shop_id">
                                                        <dt class="key">店铺：</dt>
                                                        <dd class="val">
                                                            <a :href="'#/shops/index/' + item_bidding.shop_id ">{{ item_bidding.shop_name }}</a>
                                                        </dd>
                                                    </template>
                                                    

                                                    <dt class="key">发布日期：</dt>
                                                    <dd class="val">{{ item_bidding.created_at.split(' ')[0] }}</dd>

                                                    <dd style="text-align: right;flex-grow: 1;">
                                                        <a :href="'#/bidding/' + item_bidding.id">查看详情</a>
                                                    </dd>
                                                </dl>

                                                <!-- <div class="reply"  >
                                                    <el-input style="border: 1px solid #dcdfe6 !important;border-radius:5px; margin-right:10px;" 
                                                        v-model="item_bidding.reply" placeholder="请输入内容"> </el-input>
                                                    <el-button type="primary" @click="do_reply( item_bidding )">回复</el-button>
                                                </div> -->

                                                <!-- <div class="status">

                                                    <span class="active" v-if="item_bidding.status==1"> {{item_bidding.status_text}} </span>
                                                    <span class="deactive" v-if="item_bidding.status==0"> {{item_bidding.status_text}} </span>

                                                </div> -->

                                            </div>
                                        </div>

                                    
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div style="width: 25%;float: left;margin-left: 5%">
                        <div style="line-height: 50px;font-size: 20px">推荐商品</div>
                        <div v-for="(item,index) in block_item_goods" v-bind:key="index">
                            <a :href="'#/dianpu_index/'+item.object.id">
                                <div v-if="item.object_type=='goods'"
                                     style="background: #ffffff;width: 100%;height: 340px;">

                                    <div slot="error" class="image-slot" style="width: 100%;">
                                        <img :src="url_pre+'/storage/'+item.object.cover" alt=""
                                             style="width: 100%;height: 220px">
                                        <!--                        <i class="el-icon-picture-outline"></i>-->
                                        <div style="color: #333333;font-size: 14px;margin-left: 20px">
                                            {{item.object.title}}
                                        </div>
                                        <!--                  <div class="haopin" style="color: #999999;font-size: 14px;margin-top: 10px">浏览量   2300  人</div>-->
                                        <div v-if="item.object.cash=='0.00'"
                                             style="margin-top: 15px;color: #d0320a;font-size: 16px;margin-left: 20px">
                                            {{item.object.price_yugu}}
                                        </div>
                                        <div v-if="item.object.cash!=='0.00'"
                                             style="margin-top: 15px;color: #d0320a;font-size: 16px;margin-left: 20px">
                                            {{item.object.cash}}
                                        </div>
                                    </div>

                                </div>
                            </a>
                        </div>
                        <div style="line-height: 50px;font-size: 20px">推荐服务</div>

                        <div v-for="(item_fuwu,index_fuwu) in block_item_fuwu" v-bind:key="index_fuwu">
                            <a :href="'#/dianpu_details/'+item_fuwu.object.id">
                                <div v-if="item_fuwu.object_type=='fuwu'"
                                     style="background: #ffffff;width: 100%;height: 340px;">

                                    <div slot="error" class="image-slot" style="width: 100%;">
                                        <img :src="url_pre+'/storage/'+item_fuwu.object.cover" alt=""
                                             style="width: 100%;height: 220px">
                                        <!--                        <i class="el-icon-picture-outline"></i>-->
                                        <div style="color: #333333;font-size: 14px;margin-left: 20px">
                                            {{item_fuwu.object.title}}
                                        </div>
                                        <!--                  <div class="haopin" style="color: #999999;font-size: 14px;margin-top: 10px">浏览量   2300  人</div>-->
                                        <div style="margin-top: 15px;color: #d0320a;font-size: 16px;margin-left: 20px">
                                            {{item_fuwu.object.price_yugu}}
                                        </div>

                                    </div>

                                </div>
                            </a>
                        </div>

                    </div>


                    <div data-v-6af373ef="" data-v-5c2776a4="" class="pagination-container"
                         style="line-height: 5.1em;margin-top: 60px;width: 100%">
                        <div data-v-6af373ef="" class="el-pagination is-background">
                            <span class="el-pagination__total">共 {{ zuoshuL }} 条</span>
                            <el-pagination
                                    style="float: left"
                                    layout="prev, pager, next"
                                    @current-change="yedianji"
                                    :total="zuidayema*10">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </el-main>
            <footerall></footerall>
        </el-container>
    </div>

</template>

<script>
    import home_head from '../../common/home-head';
    import footerall from "../../common/footer";
    export default {

        name:'bidding',

        data:function(){


            return {

                token:'',
                reply:'', //回复内容
                zuoshuL:'',
                zuidayema :'',

                bidding_list : [],
                bidding_search_key:'',         // 搜索关键字

                url_pre:'',
                block_item: '',
                block_item_fuwu: [],
                block_item_goods: [],
                current_page:1,
            }

        },
        components: {
            'home-head': home_head,
            footerall
        },
        methods:{

            init:function(){

                this.url_pre = window.config.api_url
                this.get_list();
                this.get_design_block();
            },

            get_list:function(){

                var t = this
                var url = window.config.api_url + '/college/bidding/index';
                
                url += '?key=' + this.bidding_search_key;
                url += '&page=' + this.current_page;

                t.axios.get(url).then(res => {

                    t.bidding_list = res.data.data;

                    t.bidding_list.forEach( item=>{

                        item.reply = ''; // 用来作为回复字段    
                        item.reply_show = 0; // 回复输入框 0：不显示，1：显示
                        t.zuoshuL = res.data.total
                        t.zuidayema = res.data.last_page
                    });

                })

            },

            do_search:function(){

                this.get_list();
            },


            showReplyHtml:function(item, value ){

                item.reply_show = value;
            },

            do_reply:function( item ){

                var t = this
                var url = window.config.api_url + '/user/bidding/reply';
                
                this.token = localStorage.getItem("uid");

                url += '?token=' + this.token;
                

                // var data = {
                //     reply : item.reply
                // };
                var formData = new FormData();
                formData.append('reply', item.reply );
                formData.append('bidding_id', item.id );
                t.axios.post( url, formData ).then(res => {
// console.log(res )
                    this.$message({
                        message: res.data.status ? res.data.description+',请先登录' : '回复成功',
                        type: res.data.status ? 'error' : 'success'
                    });
                    // todo 回复成功

                    if( !res.data.status ){
                        item.reply = '';
                    }

                })

            },

            get_design_block: function () {

                var t = this
                var url = window.config.api_url + '/college/block/shangpin/list' + '?position=jianyanjiance'
                t.axios.get(url).then(res => {
                    t.design_block = res.data;
                    for (let i = 0; i < t.design_block.length; i++) {
                        this.block_item = t.design_block[i].block_item
                    }
                    this.block_item.forEach( item =>{

                        if( item.object_type == 'fuwu'){
                            t.block_item_fuwu.push( item  )
                        }else if( item.object_type == 'goods' ){
                            t.block_item_goods.push( item  )
                        }

                    });

                    t.design_block.forEach(res => {
                        res.keywords = Array.isArray(res.keywords)
                            ? res.keywords
                            : res.keywords.split(',');
                    })
                })

            },
            yedianji(e) {
                // this.list_data(e)
                this.current_page = e;
                this.get_list(e)
            }
        },


        created:function(){

            this.init();

        }

    } 
</script>


<style>
    .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333 !important;
        margin-bottom: 25px;
        /*line-height: 40px!important;*/
        background-color: #fff;
        width: 265px;
    }

    .el-submenu .el-submenu__title {
        font-size: 18px;
        font-family: Source Han Sans CN;
        /*font-weight: bold;*/
        height: 37px !important;
        color: #FFFFFF !important;
        line-height: 42px !important;
    }

    .el-submenu .el-submenu__title:hover {
        background-color: #4E6EF2 !important;
    }

    .neitong_bufen_qiangzhi .el-tag--light {

        background-color: #4E6EF2 !important;
        color: #FFFFFF !important;
    }

    .neitong_bufen_qiangzhi .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #4E6EF2;

    }

    .neitong_bufen_qiangzhi .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #4E6EF2;
    }

    .el-checkbox__inner {
        margin-left: -15px;
    }

    .neitong_bufen_qiangzhi .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #666666 !important;
    }

    .neitong_bufen_qiangzhi .el-checkbox__inner:hover {
        border-color: #666666 !important;
    }

    .neitong_bufen_qiangzhi .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #333333 !important;
    }

    .neitong_bufen_qiangzhi .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #4E6EF2 !important;
        border-color: #333333 !important;
    }

    .neitong_bufen_qiangzhi .el-cascader .el-input .el-icon-arrow-down {
        font-size: 0px !important;
        color: #666666 !important;
    }

    .jilian_xuanzeqi_wenzi_yangshi {
        font-size: 18px !important;

    }

    .neitong_bufen_qiangzhi .el-input__inner {
        border: 0px !important;
    }

    .neitong_bufen_qiangzhi .el-tag {
        text-align: center;
        width: 120px;
        margin-top: 20px;
        padding: 0;
        height: 24px;
        line-height: 24px;
        margin-left: 2.5% !important;
    }

    .el-checkbox__label {
        font-size: 18px !important;
    }

    .el-checkbox {

        font-size: 18px !important;
    }
</style>
<style lang="less" scoped>
    @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";

    @head_text: Source Han Sans CN;
    @font-face {

    }

    @import "../../../assets/css/home";
    @import "../../../assets/css/home_second_goods";
    .flextext {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        flex: 1;
        flex-basis: auto;
        box-sizing: border-box;
        min-width: 0;
    }
    .jiance_sousuo{
        width: 400px;
    }
    

    .bidding-item {

        position:relative;
        padding:20px;

        .title{
            font-size:24px;

        }
        .description{

            margin-top:10px;
            // height:80px;
        }
        .date{

            margin-top:10px;
            display: flex;
            align-items: center;

            .avatar{
                width:30px;
                height:30px;
                border-radius:15px;
            }
            .key{
                display:inline-block;
                margin-right:10px;
            }

            .val{
                display:inline-block;
                margin-right:20px;
            }


        }
        .status{

            position:absolute;
            top:20px;
            right:20px;
            font-size: 24px;
            
            .active{
                color:rgb(75, 210, 70)
            }
            .deactive{
                color:gray;
            }
            
        }

        .reply{

            margin-top:10px;
            display:flex;

            input{
                border: 1px solid #dcdfe6 !important;
            }
            
            
        }

    }

</style>
